<div class="changeTask-popup">
    <h2 class="m-b-5" mat-dialog-title>Cambiar de Tarea</h2>
    <div mat-dialog-content>
        <form class="add-document-form" role="form" autocomplete="off" [formGroup]="form">

            <mat-form-field class="example-full-width d-block" floatLabel="always">
                <mat-label>Tipo de Tarea</mat-label>
                <mat-select formControlName="Tarea" (selectionChange)="onTaskChange($event)">
                    <mat-option *ngFor="let taskType of taskTypes" [value]="taskType.id">
                        {{taskType.texto}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <app-modern-author [authorFormGroup]="form.get('Author')">
            </app-modern-author>

            <mat-form-field class="example-full-width" floatLabel="always">
                <mat-label>Fecha</mat-label>
                <input matInput formControlName="Fecha" [matDatepicker]="TaskDate" (click)="TaskDate.open()">
                <mat-datepicker-toggle matSuffix [for]="TaskDate"></mat-datepicker-toggle>
                <mat-datepicker #TaskDate></mat-datepicker>
            </mat-form-field>
        </form>
    </div>

    <div class="text-a-r p-t-5">
        <button mat-raised-button color="accent" class="m-r-15" (click)="changeTasks()">Guardar</button>
        <button mat-raised-button color="warn" (click)="closeDialog()">Cancelar</button>
    </div>
</div>